import React, { useRef, useState, useCallback, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Snackbar,
  Alert,
  Tooltip,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
} from "@mui/material";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

// const myTypes = {
//   H: "Hire",
//   C: "Contract",
//   C2H: "Contract to Hire",
//   F: "Freelance",
//   FL: "Freelance",
// };

// const statusColors = {
//   Active: "primary",
//   "On Hold": "default",
//   Canceled: "error",
//   Full: "warning",
//   Closed: "error",
// };

// const columns = [
//   { field: "id", headerName: "ID", width: 60 },
//   {
//     field: "fullname",
//     headerName: "Full Name",
//     width: 220,
//     renderCell: (params) => (
//       <Tooltip title={params.row.title} arrow>
//         <div
//           style={{
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             maxWidth: "100%",
//           }}
//         >
//           {params.row.title}
//         </div>
//       </Tooltip>
//     ),
//   },
//   {
//     field: "email",
//     headerName: "Email",
//     width: 150,
//     renderCell: (params) => {
//       const name = params.row.client_name || "-";
//       const maxLength = 10;

//       return (
//         <Tooltip title={params.row.client_name} arrow>
//           <div
//             style={{
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               maxWidth: "100%",
//             }}
//           >
//             {name.length > maxLength
//               ? `${name.substring(0, maxLength)}...`
//               : name}
//           </div>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     field: "mobile",
//     headerName: "Mobile",
//     width: 110,
//     renderCell: (params) =>
//       params.row.company_name ? params?.row?.company_name?.split(" ")[1] : "NA",
//   },
//   {
//     field: "address",
//     headerName: "Address",
//     width: 130,
//     renderCell: (params) =>
//       params.row.approvedDate
//         ? new Date(params.row.approvedDate).toLocaleDateString()
//         : "-",
//   },
//   {
//     field: "dob",
//     headerName: "Date of Birth",
//     width: 120,
//     valueGetter: (params) => myTypes[params.value] || "N/A",
//     renderCell: (params) => myTypes[params.row.type],
//   },
//   {
//     field: "skill",
//     headerName: "Skills",
//     width: 110,
//     renderCell: (params) => (
//       <Chip
//         size="small"
//         label={params.row.status || "NA"}
//         variant="outlined"
//         color={statusColors[params.row.status] || "default"}
//       />
//     ),
//   },
//   {
//     align: "start",
//     field: "current_employer",
//     headerName: "Current Employer",
//     width: 130,
//     typeof: "date",
//     valueGetter: ({ value }) =>
//       value ? new Date(value).toLocaleDateString("en-US") : "N/A",
//     renderCell: (params) =>
//       new Date(params.row.date_created).toLocaleDateString(),
//   },
//   {
//     field: "year",
//     headerName: "Years of Experience",
//     width: 100,
//     renderCell: (params) => (params.row.count ? params.row.count : 0),
//   },
//   {
//     field: "month",
//     headerName: "Months of Experience",
//     width: 150,
//     renderCell: (params) => {
//       const name = params.row.recruiter_name || "NA";
//       const maxLength = 10;

//       return (
//         <Tooltip title={params.row.recruiter_name} arrow>
//           <div
//             style={{
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               maxWidth: "100%",
//             }}
//           >
//             {name.length > maxLength
//               ? `${name.substring(0, maxLength)}...`
//               : name}
//           </div>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     field: "linkedin",
//     headerName: "Linkedin",
//     width: 100,
//     renderCell: (params) => (
//       <Chip
//         size="small"
//         label={
//           params.row.isApproved === 1
//             ? "Approved"
//             : params.row.isApproved === 0
//             ? "Pending"
//             : "Rejected"
//         }
//         variant="outlined"
//         color={
//           params.row.isApproved === 1
//             ? "success"
//             : params.row.isApproved === 0
//             ? "warning"
//             : "error"
//         }
//       />
//     ),
//   },
//   {
//     field: "portfolio",
//     headerName: "Portfolio",
//     width: 100,
//     renderCell: (params) => (
//       <Chip
//         size="small"
//         label={
//           params.row.isApproved === 1
//             ? "Approved"
//             : params.row.isApproved === 0
//             ? "Pending"
//             : "Rejected"
//         }
//         variant="outlined"
//         color={
//           params.row.isApproved === 1
//             ? "success"
//             : params.row.isApproved === 0
//             ? "warning"
//             : "error"
//         }
//       />
//     ),
//   },
// ];

const columns = [
  {
    field: "sno",
    headerName: "S.No",
    width: 80,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "fileName",
    headerName: "File Name",
    flex: 1,
    minWidth: 150,
    sortable: true,
    disableColumnMenu: true,
  },
  {
    field: "fileSize",
    headerName: "File Size",
    width: 120,
    sortable: false,
    disableColumnMenu: true,
    valueFormatter: (params) => {
      const size = params;
      return size < 1024 * 1024
        ? `${(size / 1024).toFixed(2)} KB`
        : `${(size / (1024 * 1024)).toFixed(2)} MB`;
    },
  },
  {
    field: "status",
    headerName: "File Status",
    width: 180,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const isSuccess = params.value?.toLowerCase() === "successful";

      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            // px: 1.5,
            // py: 0.5,
            // border: `1px solid ${isSuccess ? "#2E7D32" : "#E65100"}`,
            // borderRadius: "16px",
            color: isSuccess ? "#2E7D32" : "#E65100",
            fontWeight: 500,
            fontSize: "0.875rem",
            textTransform: "capitalize",
          }}
        >
          {isSuccess ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
          ) : (
            <ErrorOutlineIcon sx={{ fontSize: 18 }} />
          )}
          {params.value}
        </Box>
      );
    },
  },
  {
    field: "message",
    headerName: "Description",
    flex: 1,
    minWidth: 150,
    sortable: false,
    disableColumnMenu: true,
  },
];

export default function BulkUploadJobs({
  pollStatus,
  setUploadProgress,
  setUploadingFiles,
  setUploadPanelOpen,
  processedFiles,
  setProcessedFiles,
  isProcessing,
  setIsProcessing,
}) {
  const nav = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [allFiles, setAllFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef();
  const addMoreFileInputRef = useRef();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });
  // const [filteredActiveJobs, setfilteredActiveJobs] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const baseURL = process.env.REACT_APP_BASEURL;

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const rows = processedFiles.map((file, index) => ({
    id: index + 1,
    sno: index + 1,
    candidateId: file.id,
    ...file,
  }));

  const filteredRows = rows.filter((row) => {
    const matchesSearch = row.fileName
      .toLowerCase()
      .includes(search.toLowerCase());
    const matchesStatus =
      statusFilter === "all" || row.status?.toLowerCase() === statusFilter;
    return matchesSearch && matchesStatus;
  });

  // const HandleRowClick = (params, event) => {
  //   const data = {
  //     id: params.row.id,
  //     title: params.row.title,
  //     type: params.row.type,
  //     status: params.row.status,
  //     date_created: params.row.date_created,
  //     count: params.row.count,
  //     openapplication: params.row.open_count,
  //     isApproved: params.row.isApproved,
  //   };
  //   nav(`/jobOrders/${params.row.id}`, {
  //     data,
  //     state: { isApproved: params.row.isApproved },
  //   });
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || e.dataTransfer.files || []);
    const MAX_SIZE_MB = 3;
    const MAX_FILE_COUNT = 501;
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
    ];
    if (files.length > MAX_FILE_COUNT) {
      setSnackbar({
        open: true,
        message: `More than ${MAX_FILE_COUNT} files are not supported.`,
        severity: "error",
      });
      return;
    }

    const currentFileCount = allFiles.length;
    if (currentFileCount + files.length > MAX_FILE_COUNT) {
      setSnackbar({
        open: true,
        // message: `Adding these would exceed the maximum of ${MAX_FILE_COUNT} files.`,
        message: `More than ${MAX_FILE_COUNT} files are not supported.`,
        severity: "error",
      });
      return;
    }
    const validFiles = [];
    const unsupportedFiles = [];
    const oversizedFiles = [];
    const duplicateNames = new Set();
    let newFileCount = currentFileCount;

    const existingNames = new Set(
      allFiles.map((f) => f.file.name.trim().toLowerCase()),
    );
    const batchNames = new Set();

    for (const file of files) {
      const nameKey = file.name.trim().toLowerCase();

      if (existingNames.has(nameKey) || batchNames.has(nameKey)) {
        duplicateNames.add(nameKey);
        continue;
      }

      if (!allowedTypes.includes(file.type)) {
        unsupportedFiles.push(file.name);
        continue;
      }

      const sizeInMB = file.size / (1024 * 1024);
      if (sizeInMB > MAX_SIZE_MB) {
        oversizedFiles.push(file.name);
        continue;
      }

      if (newFileCount >= MAX_FILE_COUNT) {
        setSnackbar({
          open: true,
          message: `A maximum of ${MAX_FILE_COUNT} files can be uploaded.`,
          severity: "warning",
        });
        break;
      }

      validFiles.push({ file, selected: true });
      batchNames.add(nameKey);
      newFileCount++;
    }

    if (duplicateNames.size > 0) {
      setSnackbar({
        open: true,
        message:
          duplicateNames.size === 1
            ? "This file has already been uploaded."
            : `${duplicateNames.size} files have already been uploaded.`,
        severity: "warning",
      });
    } else if (unsupportedFiles.length > 0) {
      setSnackbar({
        open: true,
        message:
          unsupportedFiles.length === 1
            ? "Unsupported file (only PDF, DOC, DOCX, and TXT are allowed)."
            : `${unsupportedFiles.length} unsupported files (only PDF, DOC, DOCX, and TXT are allowed).`,
        severity: "error",
      });
    } else if (oversizedFiles.length > 0) {
      setSnackbar({
        open: true,
        message:
          oversizedFiles.length === 1
            ? "Selected file exceeds the 3MB size limit."
            : `${oversizedFiles.length} files exceed the 3MB size limit and were not added.`,
        severity: "error",
      });
    }

    if (validFiles.length > 0) {
      setAllFiles((prev) => [...prev, ...validFiles]);
      setDialogOpen(false);
      setPreviewDialogOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleToggleAll = () => {
    const allSelected = allFiles.every((f) => f.selected);
    const updated = allFiles.map((f) => ({
      ...f,
      selected: !allSelected,
    }));
    setAllFiles(updated);
  };

  const getAllFilesFromItems = async (items) => {
    const files = [];

    const traverseEntry = async (entry, path = "") => {
      if (entry.isFile) {
        await new Promise((resolve, reject) => {
          entry.file(
            (file) => {
              file.fullPath = path + file.name;
              files.push(file);
              resolve();
            },
            (err) => reject(err),
          );
        });
      } else if (entry.isDirectory) {
        const reader = entry.createReader();

        const readAll = async () => {
          const entries = await new Promise((resolve, reject) => {
            reader.readEntries(resolve, reject);
          });
          if (!entries.length) return;

          for (const e of entries) {
            await traverseEntry(e, path + entry.name + "/");
          }
          await readAll();
        };

        await readAll();
      }
    };

    const roots = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry?.();
      if (entry) roots.push(entry);
    }

    for (const root of roots) {
      await traverseEntry(root, "");
    }

    return files;
  };

  const uploadAllCandidates = async (files) => {
    try {
      setIsProcessing(true);
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("resumes", file.file);
      });

      const { data } = await axios.post(
        `${baseURL}/create-bulk-candidates`,
        formData,
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );

      return data;
    } catch (error) {
      setIsProcessing(false);
      console.error("Bulk upload failed:", error);
      throw error;
    }
  };

  const handleToggleSingle = (index) => {
    const updated = [...allFiles];
    updated[index].selected = !updated[index].selected;
    setAllFiles(updated);
  };

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const items = e.dataTransfer.items;
    if (items && items.length > 0) {
      const filesFromFolders = await getAllFilesFromItems(items);

      const MAX_FILE_COUNT = 501;
      if (filesFromFolders.length > MAX_FILE_COUNT) {
        setSnackbar({
          open: true,
          message: `More than ${MAX_FILE_COUNT} files are not supported.`,
          severity: "error",
        });
        return;
      }

      handleFileChange({ target: { files: filesFromFolders } });
    }
  }, []);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const selectedCount = allFiles.filter((f) => f.selected).length;

  return (
    <Box>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        sx={{ "& .MuiPaper-root": { borderRadius: 3, width: "580px" } }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontSize={"22px"}>
              Add Bulk Candidates
            </Typography>
            <IconButton onClick={() => setDialogOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <Box sx={{ p: 4, display: "flex", flexDirection: "column", gap: 3.5 }}>
          <Box textAlign="center">
            <Typography fontSize="18px" fontWeight="700" color="#0F0F0F">
              Upload file
            </Typography>
            <Typography fontSize="12px" color="#616161">
              Please select relevant documents to complete process
            </Typography>
          </Box>

          <Box
            border={`2px dashed ${isDragging ? "#3F95EA" : "#c4c4c4"}`}
            borderRadius={2}
            p={"40px 100px 50px"}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor={isDragging ? "#F0F7FF" : "transparent"}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            sx={{
              transition: "background-color 0.3s, border-color 0.3s",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <FileUploadOutlinedIcon fontSize="large" color="primary" />
              <Typography color={isDragging ? "primary" : "inherit"}>
                Select a file/folder or drag and drop here
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                fontSize="12px"
              >
                txt, docx & pdf file size no more than{" "}
                <Typography component="span" color="#E25C72" fontSize="12px">
                  3MB
                </Typography>
              </Typography>
            </Box>
            <Button
              variant="contained"
              sx={{ width: "100%", textTransform: "capitalize" }}
              onClick={(e) => {
                e.stopPropagation();
                fileInputRef.current.click();
              }}
            >
              Select File
              <VisuallyHiddenInput
                ref={fileInputRef}
                type="file"
                multiple
                accept=".pdf,.docx,.txt,.doc"
                onChange={handleFileChange}
                webkitdirectory
                mozdirectory
                directory
              />
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog
        open={previewDialogOpen}
        onClose={() => setPreviewDialogOpen(false)}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 3,
            width: "600px",
            maxHeight: "100vh",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Add Bulk Candidates</Typography>
            <IconButton
              onClick={() => {
                setPreviewDialogOpen(false);
                setDialogOpen(true);
                setAllFiles([]);
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={1.5}
          bgcolor={"#F7F8FA"}
        >
          <Box display="flex" alignItems="center" flex={1}>
            {allFiles.length > 0 && (
              <>
                <Checkbox
                  edge="start"
                  checked={allFiles.every((f) => f.selected)}
                  indeterminate={
                    allFiles.some((f) => f.selected) &&
                    !allFiles.every((f) => f.selected)
                  }
                  onChange={handleToggleAll}
                  sx={{
                    borderRadius: "50%",
                    "& .MuiSvgIcon-root": { borderRadius: "50%" },
                  }}
                />
                <Typography fontWeight={600}>
                  {allFiles.every((f) => f.selected)
                    ? `All (${selectedCount} Candidates Selected)`
                    : `${selectedCount} Candidates Selected`}
                </Typography>
              </>
            )}
          </Box>

          <Button
            variant="contained"
            size="small"
            startIcon={<AddOutlinedIcon />}
            onClick={(e) => {
              e.stopPropagation();
              addMoreFileInputRef.current.click();
            }}
            sx={{ textTransform: "capitalize" }}
          >
            Add More Candidates
            <VisuallyHiddenInput
              ref={addMoreFileInputRef}
              type="file"
              multiple
              accept=".pdf,.docx,.txt,.doc"
              onChange={handleFileChange}
              webkitdirectory
              mozdirectory
              directory
            />
          </Button>
        </Box>

        <DialogContent dividers sx={{ maxHeight: "100vh", overflowY: "auto" }}>
          {allFiles.length > 0 ? (
            <List dense>
              {allFiles.map((f, index) => (
                <ListItem
                  key={index}
                  sx={{ py: 0, px: 0 }}
                  secondaryAction={
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => {
                        setAllFiles((prev) =>
                          prev.filter((_, i) => i !== index),
                        );
                      }}
                    >
                      <DeleteOutlineIcon color="error" />
                    </IconButton>
                  }
                >
                  <Checkbox
                    edge="start"
                    checked={f.selected}
                    onChange={() => handleToggleSingle(index)}
                    sx={{
                      borderRadius: "50%",
                      "& .MuiSvgIcon-root": {
                        borderRadius: "50%",
                      },
                    }}
                  />
                  <TaskOutlinedIcon
                    sx={{
                      mr: 2,
                      color: "#979797",
                      border: "1px solid #3F95EA33",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "38px",
                    }}
                  />

                  <ListItemText
                    primary={
                      f.file.name.length > 40
                        ? `${f.file.name.slice(0, 40)}...`
                        : f.file.name
                    }
                    secondary={
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontSize={12}
                      >
                        {f.file.size < 1024 * 1024
                          ? `${(f.file.size / 1024).toFixed(2)} KB`
                          : `${(f.file.size / (1024 * 1024)).toFixed(2)} MB`}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Box
              sx={{
                minHeight: 100,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography color="text.secondary">No files selected</Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setPreviewDialogOpen(false);
              // setDialogOpen(true);
              setAllFiles([]);
            }}
            sx={{ width: "100%", textTransform: "capitalize" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={selectedCount === 0}
            onClick={async () => {
              const selectedFiles = allFiles.filter((f) => f.selected);
              setUploadingFiles(selectedFiles);
              setUploadPanelOpen(true);
              setPreviewDialogOpen(false);
              setDialogOpen(false);
              setAllFiles([]);
              setProcessedFiles([]);
              // setDialogOpen(false);
              setUploadProgress(0);

              try {
                // setLoading(true);
                const res = await uploadAllCandidates(selectedFiles);
                // setLoading(false);
                if (res?.message?.jobId) {
                  localStorage.setItem(
                    "bulkUploadFiles",
                    JSON.stringify(selectedFiles.map((f) => f.file.name)),
                  );
                  pollStatus(res.message.jobId);
                }
              } catch (err) {
                // setLoading(false);
                console.error(err);
                setSnackbar({
                  open: true,
                  message: err.message || "Bulk upload failed",
                  severity: "error",
                });
                setUploadPanelOpen(false);
              }
            }}
            type="submit"
            sx={{ width: "100%", textTransform: "capitalize" }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* <div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "20px",
          }}
        >
          <Tooltip
            title={
              isProcessing
                ? "Bulk upload in progress. Please wait until it's finished."
                : ""
            }
            arrow
            disableHoverListener={!isProcessing}
          >
            <span>
              <Button
                variant="contained"
                size="small"
                startIcon={<GroupAddIcon />}
                onClick={() => setDialogOpen(true)}
                disabled={isProcessing}
              >
                ADD BULK CANDIDATES
              </Button>
            </span>
          </Tooltip>
        </div>
        <DataGrid
          rows={processedFiles}
          columns={columns.map((col) => ({
            ...col,
            sortable: false, // Disables sorting
            filterable: false, // Disables filtering
            disableColumnMenu: true, // Hides three-dot menu
          }))}
          autoHeight
          initialState={{
            ...processedFiles?.initialState,
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          pageSizeOptions={[5, 10, 25, { value: -1, label: "All" }]}
          onRowClick={HandleRowClick}
          className="data-grid-row-hover"
        />
      </div> */}

      <Box sx={{ backgroundColor: "F9F9F9" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <TextField
            variant="standard"
            placeholder="Search by file name..."
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          <div
            style={{
              display: "flex",
              gap: "1em",
            }}
          >
            <Box>
              <Button
                variant="contained"
                size="small"
                startIcon={<FilterListIcon />}
                onClick={handleMenuOpen}
                disabled={isProcessing}
              >
                Filter
              </Button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                <MenuItem
                  disabled={statusFilter === "all"}
                  onClick={() => {
                    setStatusFilter("all");
                    handleMenuClose();
                  }}
                >
                  All
                </MenuItem>
                <MenuItem
                  disabled={statusFilter === "successful"}
                  onClick={() => {
                    setStatusFilter("successful");
                    handleMenuClose();
                  }}
                >
                  Successful
                </MenuItem>
                <MenuItem
                  disabled={statusFilter === "failed"}
                  onClick={() => {
                    setStatusFilter("failed");
                    handleMenuClose();
                  }}
                >
                  Failed
                </MenuItem>
              </Menu>
            </Box>
            <Tooltip
              title={
                isProcessing
                  ? "Bulk upload in progress. Please wait until it's finished."
                  : ""
              }
              arrow
              disableHoverListener={!isProcessing}
            >
              <span>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<GroupAddIcon />}
                  onClick={() => setDialogOpen(true)}
                  disabled={isProcessing}
                >
                  ADD BULK CANDIDATES
                </Button>
              </span>
            </Tooltip>
          </div>
        </Box>

        <Box
          sx={{
            // height: "calc(100vh - 285px)",
            bgcolor: "white",
            borderRadius: 2,
            mt: 2,
          }}
        >
          <DataGrid
            sx={{
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-columnHeaders": {
                fontWeight: "bold",
                fontSize: "14px",
                color: "#333",
              },
              "& .MuiDataGrid-row--borderBottom": {
                backgroundColor: "#D9EAFB !important",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fafafa",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "#ffffff",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "capitalize",
                color: "#2c3e50",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                color: "#333",
                alignItems: "center",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
              },
            }}
            rows={filteredRows}
            columns={columns.map((col) => ({ ...col, resizable: true }))}
            hideFooter
            // onRowClick={(params) => {
            //   if (params.row.candidateId) {
            //     navigate(`/Manage-Candidates/${params.row.candidateId}`);
            //   }
            // }}
            getRowClassName={(params) =>
              params.row.candidateId ? "clickable-row" : "non-clickable-row"
            }
          />
        </Box>
      </Box>
    </Box>
  );
}
